import { action, observable } from 'mobx';
import moment from 'moment';
import { AccelFile } from '..';
import Entity from '../Entity';

export default class Cabinet extends Entity {
    constructor(item?: Partial<Cabinet>) {
        super(item);
        if (item) this.update(item);
    }

    @observable name: string;
    @observable createdDate: moment.Moment;
    @observable updatedDate: moment.Moment | null;
    @observable favicon: AccelFile | null;
    @observable logo: AccelFile | null;
    @observable themeJson: string | null = null;

    @action
    update(changes: Partial<Cabinet>, allowUndefined = false) {
        super.update(changes, allowUndefined);
    }

    static fromJson(json: any): Cabinet {
        return new Cabinet({
            ...json,
            createdDate: json.createdDate ? moment(json.createdDate) : undefined,
            updatedDate: json.updatedDate ? moment(json.updatedDate) : null,
            favicon: json.favicon ? AccelFile.fromJson(json.favicon) : null,
            logo: json.logo ? AccelFile.fromJson(json.logo) : null,
        });
    }
}
